import NavigationService from "@utils/NavigationService";
import { CommonActions } from "@react-navigation/native";
import createSupportTicket from "./createSupportTicket";

const exit = async (item) => {
  if (item.createTicket) {
    return createSupportTicket();
  }

  NavigationService.reset({
    index: 0,
    routes: [{ name: "MainApp" }],
  });
};

export default exit;
